<template>
    <div>
      <div v-if="debug_show_page_name==true" style="color:green;">page_0040_certificate_information_linked_devices_select</div>
        <app-header>esma</app-header>
        <div :class="'container ' +pageContainerSize">
          <title-and-search title="紐付機器選択2"></title-and-search>
          <div class="col-xs-4">
           <button class="btn btn-primary" style="min-width:100px;width: 25%;float: left;margin-left: 10px;" @click="backToList">＜　戻る</button>
          </div>
        <br>
         <br>
         <br>
          <search-control 
          style="padding-bottom: 10px;"
          :field_names="allFields" @change="searchControlChangedDatasource"></search-control>
          <ag-grid-vue style="min-width:100px;width: 100%; height: 230px" class="ag-blue" :gridOptions="gridOptions" ></ag-grid-vue>
          <div style="margin-top:5px;">
            <button :disabled="this.selected_row < 0 && this.selectedRowArr.length == 0" class="btn btn-primary" style="min-width:100px;width: 7%;float: right;margin-left: 10px;background: #92D050;border-color:#92D050;" @click="addSelected" >選択</button>
            <br>
            <br>
          </div>
        </div>
        <input-number-modal tag="showNumberModalForSetDevicesQuantity" @closed="onSelectedQty"/>
    </div>
</template>

<script>
import Vue from 'vue';
import { AgGridVue } from 'ag-grid-vue';
import { fields, filed_types } from '@/rules/fields_device_embedded_information';
import { utils } from '@/libs/utils';


import _debug from 'debug';
var mdebug = _debug('esma:certificate_information_linked_devices_select');
import acl from '@/rules/acl_rules';
import constants from '@/rules/constants';
import mixinPageCommon from '@/mixins/mixin_page_common';
import mixinDatasource from '@/mixins/mixin_datasource';

import inputNumberModal from '@/components/modals/input-number-modal';
import { bus } from '@/libs/bus';

export default {
  mixins: [mixinPageCommon,mixinDatasource],
    components: {
    'ag-grid-vue': AgGridVue,
    'input-number-modal':inputNumberModal
  },
  data() {
    return {
      local_device_control_number:null,
      api_name:"certificate_information_linked_devices_select",
      page_acl: acl.generic,
      detail_page:"page_0010_device_embedded_information_detail"
    };
  },
  computed: {
    readOnly() {
      return this.read_only;
    },
    fieldList() {
      return fields;
    },
    typeList() {
      return filed_types;
    },
    allFields(){
      return this.tabFieldList;
    },
    values() {
      console.log('values');
      return this.data_values;
    },

    filterList() {
      return this.filter_list;
    },
    tabFieldList() {
      return [
        utils.extend(fields.approval_status, {}),
        utils.extend(fields.device_control_number, {}),
        utils.extend(fields.registration_date, {}),
        utils.extend(fields.computer_name, {}),
        utils.extend(fields.equipment_in_charge_department, {}),
        utils.extend(fields.equipment_in_charge_team, {}),
        utils.extend(fields.equipment_in_charge_classification, {}),
        utils.extend(fields.equipment_in_charge_system, {}),
        utils.extend(fields.installation_department, {}),
        utils.extend(fields.installation_team, {}),
        utils.extend(fields.user_name, {}),
        utils.extend(fields.management_person_name, {}),
      ];
    }
  },
  methods: {
    addSelected(){
      bus.$emit("showNumberModalForSetDevicesQuantity",{
        title: "",
        message: "新規に組込情報を追加し証書を紐付けます。<br>組込本数を入力してください。<br><br><br>",
        input_prefix: "組込本数：",
        input_suffix: "本",
        yes_label: "組込情報を追加して紐付",
        no_label: "戻る",
        yes_style:"",
        no_style:"",
        min_val:1
      });
    },
    onSelectedQty(data){
      if(data && data.mode == "yes"){
        if(data.value > 0){
          this.saveSelected(data.value);
        }
      }
    },
    saveSelected(qty){
      // Support multiple selections.
      var obj = this.selectedRowArr.map((r)=>{
        return {
          set_qty:qty,
          associated_device_seq_id: this.$route.params.req_ad_seq_id,
          device_control_number:r.device_control_number,
          device_ebedded_information_seq_id:r.seq_id }
      });

      // Support single selection.
      if(!(obj && obj.length > 0) && this.$route.params.req_ad_seq_id.length > 0){
        obj = [{
          set_qty:qty,
          associated_device_seq_id:this.$route.params.req_ad_seq_id,
          device_control_number:this.local_device_control_number,
          device_ebedded_information_seq_id: this.selected_row}];
      };

      this.$ajax.post("/certificate_information_linked_devices/link_device/", {arr:obj}, (err, data) => {
          if(err){
            this.$notify({
              title: 'データの保存に失敗しました。',
              text: err,
              type: 'error',
              duration: 10000
            });
          }else{
            this.$notify({
              title: '紐付済',
              type: 'sucess',
              duration: 1000
            });
            setTimeout(()=>{
              return this.backToList();
            },1000)
          }
      });
    },
    backToList(){
      return this.$router.push("/certificate_information_linked_devices/list/" + this.$route.params.req_ad_seq_id + "/" + this.$route.params.cert_id );
    },
    onDetailsClick(ev, data) {
      console.log('onDetailsClick', data);
      return this.$router.push({ name: "page_0010_device_embedded_information_detail", params: {  seq_id:data.seq_id} });
    },
    addNew(){
      return this.$router.push({ name: this.detail_page, params: {  seq_id:"new"} });
    },
    createColumnDefs() {
      return this.commonCreateColumnDefs({show_details:true,show_checkbox:true})
    },
    onRowSelected(ev){
      this.local_device_control_number = ev.node.data.device_control_number;
      this.selected_row = ev.node.data.seq_id;
    }
  },
  mounted() {
    this.addHtmlClass(document.body,'blue_bg')
    this.gridOptions.api.sizeColumnsToFit();
  },
  beforeDestroy() {
    this.removeHtmlClass(document.body,'blue_bg')
  },
  beforeMount() {
    this.$store.state[this.stateCurrentRow]= {};
    this.api_request_options = {req_seq:this.$route.params.req_ad_seq_id};
    this.gridOptions = _.extend(this.commonGridOptions,{}) ;
    this.initDatasource();
  }
};
</script>
<style scoped>
.esma_btn_form {
  margin: 2px 0px;
  width: 100%;
}
.esma_blue_input_box {
  border-color: #5b9bd5;
}
.esma_blue_input_div {
  margin-right: 2px;
}
input:focus::-webkit-input-placeholder {
  color: transparent;
}
</style>



// WEBPACK FOOTER //
// page_0040_certificate_information_linked_devices_select.vue?d556d800